import React from "react";

function TimelineTrack({
  currentTime = 0,
  duration = 0,
  onSeek,
  fps = 29.97,
  className = "",
  disabled = false,
  ariaLabel = "",
}) {
  const totalSeconds = Math.max(
    duration > 0 ? duration : 0,
    currentTime > 0 ? currentTime : 0
  );
  const isDisabled = disabled || totalSeconds <= 0;

  return (
    <div
      className={`w-full ${className}`}
      role="group"
      aria-label={ariaLabel || "Video timeline"}
    >
      <input
        type="range"
        min={0}
        max={totalSeconds}
        step={fps ? 1 / fps : 0.01}
        value={Math.min(currentTime, totalSeconds)}
        disabled={isDisabled}
        onChange={(event) =>
          onSeek && onSeek(parseFloat(event.target.value))
        }
        aria-label="Seek video"
        className="timeline-range w-full cursor-pointer disabled:cursor-default disabled:opacity-50"
      />
    </div>
  );
}

export default TimelineTrack;